import { Chapter } from "./Chapter";

export class Course {
    course: ICourse;
    chapters: Chapter[] = [];
    dom: HTMLDivElement;
    parent: HTMLElement;
    contentSection: HTMLDivElement;
  
    constructor(data: ICourse,parent: HTMLElement) {
      this.course = data;
      this.contentSection = document.querySelector(
        "#content-section"
      ) as HTMLDivElement;
      this.dom = document.createElement("div");
      this.course.children.forEach((chapter) => {
        if (chapter?.data) {
          const newChapter = new Chapter(chapter, this);
          this.chapters.push(newChapter);
        }
      });
      this.parent = parent
      if (this.parent) {
        this.chapters.forEach((chapter) => {
          this.dom.appendChild(chapter.dom);
        });
        this.parent.appendChild(this.dom);
      }
    }
  }